
const ProcessingFees = () => {
  return(
    <div>Processing Fees</div>
  )
}

export default ProcessingFees